module.exports = __webpack_public_path__ + "img/part-4-title.de8ae3b3.png";